<template>
  <v-card flat>
    <v-card-text>
      <p>
        <span style="background-color: yellow">Texto Alterado</span>
        <span
          class="ml-4"
        >* Os textos marcados em amarelo tiveram alterações em relação a
          versão anterior.</span>
      </p>
      <historico-responsabilidade-item
        v-for="item in itensHistorico"
        :key="item.id"
        :item="item"
      />
    </v-card-text>
  </v-card>
</template>

<script>
import HistoricoResponsabilidadeItem from '@/components/mapeamento/HistoricoResponsabilidadeItem';

export default {
  name: 'HistoricoResponsabilidadeList',

  components: {
    HistoricoResponsabilidadeItem,
  },

  props: {
    responsabilidade: {
      type: Object,
      default: () => {},
      required: true,
    },
    etapa: {
      type: String,
      default: '',
      required: true,
    },
  },

  computed: {
    itensHistorico() {
      const resultado = [];
      let id = 0;
      resultado.push({
        id: (id += 1),
        usuario: this.responsabilidade.usuarioGestor,
        papel: 'Gestor',
        status: 'Original',
        titulo: this.responsabilidade.titulo,
        dificuldade: this.responsabilidade.dificuldade,
        impacto: this.responsabilidade.impacto,
        competencias: this.responsabilidade.competenciasTecnicas.slice().sort((a, b) => a.nome.localeCompare(b.nome)),
        hasDiffCompetencias: false,
        tituloBackgroundColor: null,
        impactoBackgroundColor: null,
        dificuldadeBackgroundColor: null,
      });

      if (this.responsabilidade.usuarioComissao && !this.responsabilidade.excluida && this.ordemEtapa > 1) {
        resultado.push({
          id: (id += 1),
          usuario: this.responsabilidade.usuarioComissao,
          papel: 'DIGEC',
          status: this.responsabilidade.normalizada ? 'Normalizada' : 'Editada',
          titulo: this.responsabilidade.tituloComissao,
          dificuldade: this.responsabilidade.dificuldadeComissao,
          impacto: this.responsabilidade.impactoComissao,
          competencias: this.responsabilidade.competenciasTecnicasComissao
            .slice()
            .map((c) => ({
              id: c.id,
              nome: c.nomeNormalizacao ? c.nomeNormalizacao : c.nomeAtual,
              unidades: c.unidades,
              competenciasAgrupadas: c.competenciasAgrupadas.map((c2) => ({ id: c2.id, nome: c2.nome })),
            }))
            .sort((a, b) => a.nome && a.nome.localeCompare(b.nome)),
          hasDiffCompetencias: this.hasDiffCompetencias(
            this.responsabilidade.competenciasTecnicasComissao.map((c) => ({
              id: c.id,
              nome: c.nomeNormalizacao ? c.nomeNormalizacao : c.nomeAtual,
            })),
            this.responsabilidade.competenciasTecnicas,
          ),
          tituloBackgroundColor: null,
          impactoBackgroundColor: null,
          dificuldadeBackgroundColor: null,
        });
      }

      if (this.responsabilidade.usuarioChefia && !this.responsabilidade.excluida && this.ordemEtapa > 2) {
        resultado.push({
          id: (id += 1),
          usuario: this.responsabilidade.usuarioChefia,
          papel: 'Validador',
          status: this.responsabilidade.validada ? 'Validada' : 'Editada',
          titulo: this.responsabilidade.tituloChefia,
          dificuldade: this.responsabilidade.dificuldadeChefia,
          impacto: this.responsabilidade.impactoChefia,
          competencias: this.responsabilidade.competenciasTecnicasChefia
            .slice()
            .map((c) => ({
              id: c.id,
              nome: c.nomeValidacao ? c.nomeValidacao : c.nomeAtual,
              unidades: c.unidades,
              competenciasAgrupadas: c.competenciasAgrupadas.map((c2) => ({
                id: c2.id,
                nome: c2.nomeNormalizacao ? c2.nomeNormalizacao : c2.nomeAtual,
              })),
            }))
            .sort((a, b) => a.nome.localeCompare(b.nome)),
          hasDiffCompetencias: this.hasDiffCompetencias(
            this.responsabilidade.competenciasTecnicasChefia.map((c) => ({
              id: c.id,
              nome: c.nomeValidacao ? c.nomeValidacao : c.nomeAtual,
            })),
            this.responsabilidade.competenciasTecnicasComissao.map((c) => ({
              id: c.id,
              nome: c.nomeNormalizacao ? c.nomeNormalizacao : c.nomeAtual,
            })),
          ),
          tituloBackgroundColor: null,
          impactoBackgroundColor: null,
          dificuldadeBackgroundColor: null,
        });
      }

      if (this.responsabilidade.usuarioConsolidacao && !this.responsabilidade.excluida && this.ordemEtapa > 3) {
        resultado.push({
          id: (id += 1),
          usuario: this.responsabilidade.usuarioConsolidacao,
          papel: 'DIGEC',
          status: this.responsabilidade.consolidada ? 'Consolidada' : 'Editada',
          titulo: this.responsabilidade.tituloConsolidado,
          dificuldade: this.responsabilidade.dificuldadeConsolidado,
          impacto: this.responsabilidade.impactoConsolidado,
          competencias: this.responsabilidade.competenciasTecnicasConsolidado
            .slice()
            .map((c) => ({
              id: c.id,
              nome: c.nomeConsolidacao ? c.nomeConsolidacao : c.nomeAtual,
              unidades: c.unidades,
              competenciasAgrupadas: c.competenciasAgrupadas.map((c2) => ({
                id: c2.id,
                nome: c2.nomeValidacao ? c2.nomeValidacao : c2.nomeAtual,
              })),
            }))
            .sort((a, b) => a.nome.localeCompare(b.nome)),
          hasDiffCompetencias: this.hasDiffCompetencias(
            this.responsabilidade.competenciasTecnicasConsolidado.map((c) => ({
              id: c.id,
              nome: c.nomeConsolidacao ? c.nomeConsolidacao : c.nomeAtual,
            })),
            this.responsabilidade.competenciasTecnicasChefia.map((c) => ({
              id: c.id,
              nome: c.nomeValidacao ? c.nomeValidacao : c.nomeAtual,
            })),
          ),
          tituloBackgroundColor: null,
          impactoBackgroundColor: null,
          dificuldadeBackgroundColor: null,
        });
      }

      if (resultado.length > 1) {
        for (let i = 1; i < resultado.length; i += 1) {
          const respAnterior = resultado[i - 1];
          const respAtual = resultado[i];

          if (respAnterior.titulo !== respAtual.titulo) {
            respAtual.tituloBackgroundColor = 'yellow';
          }

          if (respAnterior.impacto.id !== respAtual.impacto.id) {
            respAtual.impactoBackgroundColor = 'yellow';
          }

          if (respAnterior.dificuldade.id !== respAtual.dificuldade.id) {
            respAtual.dificuldadeBackgroundColor = 'yellow';
          }
        }
      }

      return resultado;
    },
    ordemEtapa() {
      switch (this.etapa) {
        case 'cadastro':
          return 1;
        case 'normalizacao':
          return 2;
        case 'validacao':
          return 3;
        case 'consolidacao':
          return 4;
        default:
          return 0;
      }
    },
  },

  methods: {
    hasDiffCompetencias(competencias, competenciasAnteriores) {
      let hasDiff = false;
      if (competencias.length !== competenciasAnteriores.length) {
        hasDiff = true;
      } else {
        competencias.forEach((c) => {
          if (!competenciasAnteriores.some((cA) => cA.nome.trim() === c.nome.trim())) {
            hasDiff = true;
          }
        });
      }
      return hasDiff;
    },
  },
};
</script>
